/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section3_Li2Inputs */

const en_terms_section3_li2 = /** @type {(inputs: Terms_Section3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attempt to interfere with or disrupt the service's availability`)
};

const ko_terms_section3_li2 = /** @type {(inputs: Terms_Section3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서비스의 가용성을 방해하거나 중단시키려는 시도`)
};

const ja_terms_section3_li2 = /** @type {(inputs: Terms_Section3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスの可用性を妨害または中断しようとすること`)
};

/**
* | output |
* | --- |
* | "Attempt to interfere with or disrupt the service's availability" |
*
* @param {Terms_Section3_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section3_li2 = /** @type {((inputs?: Terms_Section3_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section3_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section3_li2(inputs)
	if (locale === "ko") return ko_terms_section3_li2(inputs)
	return ja_terms_section3_li2(inputs)
});